import React from 'react';

interface UsageMeterProps {
    used: number;
    limit: number;
    label: string;
    unit?: string;
}

export function UsageMeter({ used, limit, label, unit = '' }: UsageMeterProps) {
    const percentage = limit ? Math.min(100, (used / limit) * 100) : 0;
    const remaining = limit - used;

    return (
        <div>
            <div className="flex items-center justify-between text-sm">
                <h4 className="font-medium">{label}</h4>
                <span className="tabular-nums">
                    {used} / {limit} {unit}
                </span>
            </div>
            <div className="mt-1 h-2 w-full rounded-full bg-gray-200">
                <div
                    className="h-full rounded-full bg-green-600"
                    style={{ width: `${percentage}%` }}
                />
            </div>
            <div className="mt-1 flex justify-between text-sm text-gray-600">
                <span>{used} {unit} used</span>
                <span>{remaining} {unit} remaining</span>
            </div>
        </div>
    );
}